import { ReactComponent as GroupIcon } from 'assets/images/ic-group.svg';
import { ReactComponent as UserIcon } from 'assets/images/ic-user.svg';
import { getFiBankStore } from 'stores/FiBankStore';
import type { SelectOption } from 'ui';

export const getRelationshipManagerOptions = () => {
  const bankStore = getFiBankStore();
  const usersOptions: SelectOption[] = bankStore.staff
    .filter((u) => u.invitation_status === 'accepted')
    .map((s) => {
      return {
        label: `${s.firstName} ${s.lastName}`,
        value: s.id,
        icon: (
          <UserIcon
            style={{ position: 'relative', top: '3px', right: '5px', height: '24px', width: '24px' }}
          />
        )
      };
    });

  const groupOptions: SelectOption[] = bankStore.bank.groups
    .filter((g) => g.users.length)
    .map((g) => {
      return {
        label: g.name,
        value: g.id,
        icon: (
          <GroupIcon
            style={{ position: 'relative', top: '3px', right: '5px', height: '24px', width: '24px' }}
          />
        )
      };
    });
  const relationshipManagerOptions = [{ label: 'None', value: 'none' }, ...usersOptions, ...groupOptions];
  return relationshipManagerOptions;
};
